import React from 'react';
import { AlertTriangle, Phone, Mail } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const TenantSuspendedModal = ({ open, onLogout }) => {
  return (
    <Dialog open={open} onOpenChange={() => {}} modal={true}>
      <DialogContent className="max-w-md" onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-10 h-10 text-red-600" />
            </div>
          </div>
          <DialogTitle className="text-center text-2xl">Établissement Bloqué</DialogTitle>
          <DialogDescription className="text-center text-base pt-4">
            Votre établissement a été temporairement suspendu.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-sm text-red-800 text-center">
              L'accès à votre compte est actuellement bloqué. Cela peut être dû à un problème de paiement ou à une autre raison administrative.
            </p>
          </div>

          <div className="border-t pt-4">
            <p className="text-sm font-medium text-gray-700 mb-3 text-center">
              Pour régulariser votre situation, veuillez contacter l'administrateur :
            </p>
            
            <div className="space-y-2">
              <div className="flex items-center justify-center space-x-2 text-sm">
                <Mail className="w-4 h-4 text-gray-500" />
                <a href="mailto:admin@eduscope.com" className="text-blue-600 hover:underline">
                  admin@eduscope.com
                </a>
              </div>
              
              <div className="flex items-center justify-center space-x-2 text-sm">
                <Phone className="w-4 h-4 text-gray-500" />
                <span className="text-gray-700">+224 XXX XX XX XX</span>
              </div>
            </div>
          </div>

          <Button 
            onClick={onLogout}
            className="w-full"
            variant="outline"
          >
            Se Déconnecter
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TenantSuspendedModal;
